<lib-generic-dropdown-multiselect
    [selectedItems]="selectedProductTypesItems"
    [config]="{
        multiple: true,
        defaultText: 'Add productType',
        itemDisplayKey: 'productTypeName'
    }"
    [isReadOnly]="true"
>
</lib-generic-dropdown-multiselect>
